export default function Section_4() {
    return (<>
        <section className="fourth-section h-screen relative">

        <div class="absolute inset-0 flex items-center justify-center mt-44 lg:mt-0">
            <div class="bg-[#FB3D3D] rounded-full relative -z-10 w-[80vw] h-[80vw] sm:w-[50vw] sm:h-[50vw] md:w-[40vw] md:h-[40vw] lg:w-[35vw] lg:h-[35vw]"></div>
        </div>


                <div style={{ marginTop: '-3rem' }} className="absolute top-0 left-0 w-1/2 h-1/2 flex items-center justify-center"> 
                <h1 style={{ marginLeft: '33%' }} className="text-5xl sm:text-4xl md:text-4xl lg:text-7xl text-white whitespace-nowrap mt-34 lg:mt-0 font-ranga">photo m8</h1>
            </div>

            <div className="absolute bottom-8 right-0 w-3/4 lg:w-1/2 h-1/2 flex flex-col items-start justify-center mr-4 lg:mr-0 mb-0 sm:mb-0">
                <div className="text-left ml-24 text-white">
                    <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-3xl mb-4 text-center mt-64 lg:mt-0 font-manrope">Shutter Majestic</h2>
                    <p className="text-sm sm:text-base md:text-base lg:text-lg text-center font-manrope">Bring your vision to life with unparalleled accuracy.</p>
                </div>
            </div>
        </section>  
    </>)
}
